module.exports = __webpack_public_path__ + "static/media/pozadi_trojuhelniky_sd.8ad0fd5c.png";